export default __webpack_public_path__ + "static/media/checkedIcon.31fc3b52.svg";